module.exports = __webpack_public_path__ + "img/train.18327008.png";